/**
 * Utility function to convert conversation records into CSV and trigger download.
 */

function escapeCSV(val) {
  if (val === null || val === undefined) return '""';
  const str = String(val).replace(/"/g, '""');
  return `"${str}"`;
}

export function exportConversationsToCSV(conversations, filename = "spincycles_conversations.csv") {
  if (!Array.isArray(conversations) || conversations.length === 0) {
    throw new Error("No conversation data available to export.");
  }

  const headers = [
    "Conversation ID",
    "Conversation Title",
    "User Type",
    "Customer Name",
    "Mobile Number",
    "Email",
    "Customer CUID",
    "Guest Session ID",
    "Customer Type",
    "Messages Count",
    "Chat Status",
    "Ops Status",
    "Evaluation Remarks",
    "Evaluator Name",
    "Evaluated At",
    "Converted",
    "Booking Source",
    "Booking Source ID",
    "Booking Type",
    "Booking Reference ID",
    "Booking Status",
    "Booking Amount (INR)",
    "Booked Services",
    "Scheduled Date",
    "Scheduled Time Slot",
    "Booking Placed At",
    "Chat Created At",
    "Chat Last Active At",
    "Last Message Snippet",
  ];

  const rows = conversations.map((c) => {
    const cust = c.customer || c.user_details || {};
    const evalData = c.evaluation || {};
    const convDetails = c.conversion_details || {};

    const isCustomer = c.user_type === "customer";
    const custTypeLabel =
      (c.is_new || "").toLowerCase() === "new"
        ? "New"
        : (c.is_new || "").toLowerCase() === "old"
        ? "Old / Returning"
        : c.is_new || "";

    const bookingType =
      convDetails.type_label ||
      (convDetails.type === "pickup_request"
        ? "Pickup Request"
        : convDetails.type === "order"
        ? "Order"
        : convDetails.type || "");

    return [
      escapeCSV(c.id),
      escapeCSV(c.title || "Untitled Session"),
      escapeCSV(isCustomer ? "Customer" : "Guest"),
      escapeCSV(cust.name || (isCustomer && cust.cuid ? `Customer #${cust.cuid}` : "Guest User")),
      escapeCSV(cust.mobile || ""),
      escapeCSV(cust.email || ""),
      escapeCSV(cust.cuid || ""),
      escapeCSV(c.guest_session_id || ""),
      escapeCSV(custTypeLabel),
      escapeCSV(c.message_count || 0),
      escapeCSV(c.status || ""),
      escapeCSV(c.ops_status || evalData.status || "Pending"),
      escapeCSV(evalData.remarks || ""),
      escapeCSV(evalData.evaluator_name || ""),
      escapeCSV(evalData.evaluated_at || ""),
      escapeCSV(c.is_converted || "No"),
      escapeCSV(convDetails.source || (c.is_converted === "Yes" ? "Direct / Store" : "")),
      escapeCSV(convDetails.source_id !== undefined && convDetails.source_id !== null ? convDetails.source_id : ""),
      escapeCSV(bookingType),
      escapeCSV(convDetails.id || convDetails.reference_id || ""),
      escapeCSV(convDetails.status || ""),
      escapeCSV(
        convDetails.amount !== undefined && convDetails.amount !== null
          ? Number(convDetails.amount).toFixed(2)
          : ""
      ),
      escapeCSV(convDetails.services || ""),
      escapeCSV(convDetails.request_date || ""),
      escapeCSV(convDetails.time_slot || ""),
      escapeCSV(convDetails.created_at || ""),
      escapeCSV(c.created_at || ""),
      escapeCSV(c.last_message_at || c.updated_at || ""),
      escapeCSV((c.last_message || "").replace(/[\r\n]+/g, " ")),
    ].join(",");
  });

  // Prepend UTF-8 BOM so Excel opens the file cleanly without character encoding issues
  const csvContent = "\uFEFF" + [headers.join(","), ...rows].join("\r\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

